import authRules from '../authRules';

const assignments = (user) => {
  const { assignments } = user.securityLevels;
  if (assignments >= authRules.assignments.assignments) {
      return true;
  } else {
      return false;
    }
  }

export default assignments;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/assignments.js